import { ListOrdered, Settings2 } from 'lucide-react'

import type { NavItem } from '@/shared/layout/navigation'

const base = { group: 'nav.groups.finance', permission: 'finance.view' } as const

export const financeNavigation: NavItem[] = [
  { ...base, to: '/finance/entries', labelKey: 'nav.financeEntries', icon: ListOrdered },
  { ...base, to: '/finance/settings', labelKey: 'nav.financeSettings', icon: Settings2 },
]
